import React, { useEffect, useRef, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import "./index.less";
import {
  TwoSliderHorizontalIcon,
  NavigationIcon,
  FoodAndDrinkIcon,
  SortDownIcon,
  CheckIcon,
} from "@/icons";
import { useFilterContext } from "@/ui/head-bar/filter-context";
import { FiltersDialog } from "@/ui/filters/desktop";
import Popover from "@/ui/popover";
import { observer } from "mobx-react-lite";

const filters = [
  {
    key: "filters",
    icon: <TwoSliderHorizontalIcon></TwoSliderHorizontalIcon>,
    label: "Filters",
  },
  {
    key: "location",
    icon: <NavigationIcon></NavigationIcon>,
    label: "Location",
  },
  {
    key: "cuisines",
    icon: <FoodAndDrinkIcon></FoodAndDrinkIcon>,
    label: "Cuisines",
  },
];

function Filters() {
  const { t } = useTranslation();
  const { filterParams, state, setState, sums } = useFilterContext();
  const [activeFilters, setActiveFilters] = React.useState("");
  const [isSortActive, setIsSortActive] = useState(false);
  const ref = useRef(null);
  const dialogConfig = useMemo(() => {
    return {
      title: t(`Browse.${activeFilters}`),
      open: activeFilters !== "",
      type: activeFilters,
      close: () => setActiveFilters(""),
    };
  }, [activeFilters]);

  return (
    <div className="explore-filters">
      <Popover
        placement="bottom-start"
        trigger="click"
        open={isSortActive}
        content={
          <div className="explore-sort-popover-content" ref={ref}>
            {filterParams?.order_by?.map((option) => (
              <div
                key={option.value}
                className={cn("explore-sort-popover-item", {
                  active: state.sort === option.value,
                })}
                onClick={() => {
                  setState({ sort: option.value });
                  setIsSortActive(false);
                }}
              >
                <div className="label">{option.name}</div>
                {state.sort === option.value && <CheckIcon></CheckIcon>}
              </div>
            ))}
          </div>
        }
        onOpenChange={(open) => {
          setIsSortActive(open);
        }}
        overlayClassName="explore-sort-popover"
      >
        <div
          className={cn("explore-filter-item", {
            active: isSortActive,
          })}
        >
          <SortDownIcon></SortDownIcon>
          <span>{t("Browse.sort")}</span>
          {sums.sort > 0 && (
            <div className="explore-filter-item-badge">{sums.sort}</div>
          )}
        </div>
      </Popover>

      {filters.map((filter) => (
        <div
          key={filter.key}
          className="explore-filter-item"
          onClick={() => setActiveFilters(filter.key)}
        >
          {filter.icon}
          <span>{t(`Browse.${filter.key}`)}</span>
          {sums[filter.key] > 0 && (
            <div className="explore-filter-item-badge">{sums[filter.key]}</div>
          )}
        </div>
      ))}
      {dialogConfig.open && <FiltersDialog {...dialogConfig}></FiltersDialog>}
    </div>
  );
}

export default observer(Filters);
